import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { can } from "../utils/permissionUtils";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  logout,
  selectUser,
  selectPermissions,
} from "../store/slices/authSlice";

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectUser);
  const permissions = useAppSelector(selectPermissions);
  const name = user?.name;
  const role = user?.role;

  const isSuperAdmin = role === "superadmin";

  const handleLogout = (e) => {
    e.preventDefault();
    sessionStorage.clear();
    dispatch(logout());
    navigate("/");
  };

  // Helper: superadmin ko sab kuch dikhao, baaki ko permission check karo
  const canRead = (module) => isSuperAdmin || can(permissions, "read", module);

  return (
    <div className={`sidebar ${sidebarOpen ? "open" : ""}`} id="sidebar">
      {" "}
      {/* ================= PROFILE + TABS ================= */}
      <div className="modern-profile p-3 pb-0">
        <div className="sidebar-nav mb-3">
          <ul
            className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
            role="tablist"
          >
            <li className="nav-item">
              <button className="nav-link active border-0 btn btn-link p-0">
                Menu
              </button>
            </li>

            {canRead("chat") && (
              <li className="nav-item">
                <Link className="nav-link border-0" to="/chat">
                  Chats
                </Link>
              </li>
            )}
            {canRead("project") && (
              <li>
                <Link to="/projects">
                  <i className="ti ti-briefcase" />
                  <span>Projects</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      {/* ================= ICON HEADER ================= */}
      <div className="sidebar-header p-3 pb-0 pt-2">
        <div className="d-flex align-items-center justify-content-between menu-item mb-3">
          <div className="me-3">
            <button className="btn btn-icon border btn-menubar">
              <i className="ti ti-layout-grid-remove" />
            </button>
          </div>

          {canRead("chat") && (
            <div className="me-3">
              <Link
                to="/chat"
                className="btn btn-icon border btn-menubar position-relative"
              >
                <i className="ti ti-brand-hipchat" />
              </Link>
            </div>
          )}

          <div className="me-3 notification-item">
            <button className="btn btn-icon border btn-menubar position-relative me-1">
              <i className="ti ti-bell" />
              <span className="notification-status-dot" />
            </button>
          </div>

          <div className="me-0">
            <Link to="/emails" className="btn btn-icon border btn-menubar">
              <i className="ti ti-message" />
            </Link>
          </div>
        </div>
      </div>
      {/* ================= SIDEBAR CONTENT ================= */}
      <div className="sidebar-inner slimscroll">
        <div id="sidebar-menu" className="sidebar-menu">
          {/* USER INFO  */}
          <ul>
            <li className="clinicdropdown">
              <Link to="/">
                <div className="user-names px-3">
                  <h5>{name}</h5>
                  <h6>{role}</h6>
                </div>
              </Link>
            </li>
          </ul>

          {/* MENU LIST */}
          <ul>
            <li>
              <ul className="sidebar-menu">
                {/* module key: "dashboard" */}
                {canRead("dashboard") && (
                  <li>
                    <Link to="/dashboard" onClick={() => setSidebarOpen(false)}>
                      <i className="ti ti-home" />
                      <span>Dashboard</span>
                    </Link>
                  </li>
                )}
                {/* module key: "type" */}
                {/* {canRead("type") && (
                  <li>
                    <Link to="/type" onClick={() => setSidebarOpen(false)}>
                      {" "}
                      <i className="ti ti-building-community" />
                      <span>Type Management</span>
                    </Link>
                  </li>
                )} */}
                {/* module key: "group" */}
                {/* {canRead("group") && (
                  <li>
                    <Link to="/group">
                      <i className="ti ti-users-group" />
                      <span>Group Management</span>
                    </Link>
                  </li>
                )} */}
                {/* module key: "source" */}
                {canRead("source") && (
                  <li>
                    <Link to="/source">
                      <i className="ti ti-link" />
                      <span>Source Management</span>
                    </Link>
                  </li>
                )}
                {/* module key: "role" */}
                {canRead("role") && (
                  <li>
                    <Link to="/role">
                      <i className="ti ti-id" />
                      <span>Role Management</span>
                    </Link>
                  </li>
                )}
                {/* module key: "user" */}
                {canRead("user") && (
                  <li>
                    <Link to="/new-user">
                      <i className="ti ti-user-cog" />
                      <span>User Management</span>
                    </Link>
                  </li>
                )}
                {/* module key: "leadassign" */}
                {/* LEAD SHUFFLE - SUPER ADMIN ONLY */}
                {isSuperAdmin && (
                  <li>
                    <Link
                      to="/lead-shuffle"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <i className="ti ti-arrows-shuffle" />
                      <span>Lead Shuffle</span>
                    </Link>
                  </li>
                )}
                {/* {canRead("leadassign") && (
                  <li>
                    <Link to="/leadSetting">
                      <i className="ti ti-world" />
                      <span>Lead Setting</span>
                    </Link>
                  </li>
                )} */}
                {/* <Link to="/zoho-connect">
                    <i className="ti ti-calendar-event"></i>
                    <span>Zoho Connect</span>
                  </Link> */}
                {/* <li>

                  <Link to="/google-connect">
                    <i className="ti ti-brand-google"></i>
                    <span>Google Connect</span>
                  </Link>
                </li> */}
                {/* <li>
                  <Link to="/my-availability">
                    <i className="ti ti-clock"></i>
                    <span>My Availability</span>
                  </Link>
                </li>
                <li>
                  <Link to="/my-meetings">
                    <i className="ti ti-calendar"></i>
                    <span>My Meetings</span>
                  </Link>
                </li> */}
                {/* MY AVAILABILITY */}
                {canRead("my-availability") && (
                  <li>
                    <Link
                      to="/my-availability"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <i className="ti ti-clock" />
                      <span>My Availability</span>
                    </Link>
                  </li>
                )}
                {/* MY MEETINGS */}
                {canRead("my-meetings") && (
                  <li>
                    <Link
                      to="/my-meetings"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <i className="ti ti-calendar" />
                      <span>My Meetings</span>
                    </Link>
                  </li>
                )}
                {canRead("lead") && (
                  <li>
                    <Link
                      to="/lead-management"
                      onClick={() => setSidebarOpen(false)}
                    >
                      {" "}
                      <i className="ti ti-user-plus" />
                      <span>Lead Management</span>
                    </Link>
                  </li>
                )}
                {canRead("lead") && (
                  <li>
                    <Link to="/payments">
                      <i className="ti ti-credit-card" />
                      <span>Payments</span>
                    </Link>
                  </li>
                )}
                {canRead("template") && (
                  <li>
                    <Link to="/template">
                      <i className="ti ti-medal" />
                      <span>Templates</span>
                    </Link>
                  </li>
                )}
                {/* {canRead("selltemplate") && (
                  <li>
                    <Link to="/sell-template">
                      <i className="ti ti-medal" />
                      <span>Sell Templates</span>
                    </Link>
                  </li>
                )} */}
                {/* module key: "projectmodules" */}
                {/* {canRead("projectmodules") && (
                  <li>
                    <Link to="/project-modules">
                      <i className="ti ti-box" />
                      <span>Project Modules</span>
                    </Link>
                  </li>
                )} */}
                {canRead("projectpackage") && (
                  <li>
                    <Link to="/project-package">
                      <i className="ti ti-box" />
                      <span>Project Package</span>
                    </Link>
                  </li>
                )}
                {/* module key: "project" */}
                {/* {canRead("project") && (
                  <li>
                    <Link to="/project-progress">
                      <i className="ti ti-adjustments" />
                      <span>Project Progress</span>
                    </Link>
                  </li>
                )} */}
                {/* {canRead("project-progress") && (
                  <li>
                    <Link
                      to="/project-progress"
                      style={{
                        pointerEvents: "none",
                        opacity: 0.5,
                        cursor: "not-allowed",
                      }}
                    >
                      <i className="ti ti-adjustments" />
                      <span>Project Progress</span>
                    </Link>
                  </li>
                )} */}
                {/* PROJECTS */}{" "}
                {canRead("project") && (
                  <li>
                    {" "}
                    <Link to="/projects">
                      {" "}
                      <i className="ti ti-briefcase" />{" "}
                      <span>Projects</span>{" "}
                    </Link>{" "}
                  </li>
                )}
                {/* ASSIGNED TESTING */}
                {canRead("assigned-testing") && (
                  <li>
                    <Link to="/assigned-testing">
                      <i className="ti ti-test-pipe" />
                      <span>Assigned Testing</span>
                    </Link>
                  </li>
                )}
                {/* TEST CASES */}
                {canRead("test-cases") && (
                  <li>
                    <Link to="/test-cases">
                      <i className="ti ti-list-check" />
                      <span>Test Cases</span>
                    </Link>
                  </li>
                )}
                {/* BUG MANAGEMENT */}
                {canRead("bugs") && (
                  <li>
                    <Link to="/bugs">
                      <i className="ti ti-bug" />
                      <span>Bug Management</span>
                    </Link>
                  </li>
                )}
                {/* ASSIGNED BUGS - DEVELOPER */}
                {canRead("assigned-bugs") && (
                  <li>
                    <Link to="/my-bugs" onClick={() => setSidebarOpen(false)}>
                      <i className="ti ti-bug" />
                      <span>Assigned Bugs</span>
                    </Link>
                  </li>
                )}
                {/* TESTING REPORTS */}
                {canRead("testing-reports") && (
                  <li>
                    <Link to="/testing-reports">
                      <i className="ti ti-report-analytics" />
                      <span>Testing Reports</span>
                    </Link>
                  </li>
                )}
                {/* module key: "chat" */}
                {canRead("chat") && (
                  <li>
                    <Link to="/chat">
                      <i className="ti ti-message" />
                      <span>Chat Window</span>
                    </Link>
                  </li>
                )}
                {/* {canRead("chat") && (
                  <li>
                    <Link
                      to="/chat"
                      style={{
                        pointerEvents: "none",
                        opacity: 0.5,
                        cursor: "not-allowed",
                      }}
                    >
                      <i className="ti ti-message" />
                      <span>Chat Window</span>
                    </Link>
                  </li>
                )} */}
                <li onClick={handleLogout}>
                  <Link>
                    <i className="ti ti-lock-cog" />
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </li>
            a
          </ul>
        </div>
      </div>
    </div>
  );
}
export default Sidebar;


